<div class="navsrch fiori3-input-group">
  <input type="text" class="form-control" id="menuSearch" placeholder="{{'Admin.Sidemenu.SearchMenu' | translate}}" [(ngModel)]="searchKeyWord" (ngModelChange)="search()">
  <span class="input-group-icon">
    <button type="button" class="btn btn-default btn-main removeOutlineOnFocus" (click)='resetMenuSearch()'>
      @if (searchKeyWord) {
        <span class="sap-icon">&#xe03e;</span>
      }
    </button>
    @if (!searchKeyWord) {
      <span class="sap-icon">&#xe00d;</span>
    }
  </span>
</div>
<em [style.display]="numOfItems>0 ? 'block' : 'none'" class="items-matched">
  <small>{{numOfItems}}&nbsp;{{'Admin.Sidemenu.NumberOfItems' | translate}}</small>
</em>